import React from "react";
import { Sparkles, Activity } from "lucide-react";
import { automationLevel } from "../ConnectorSummary";

const TONE_PILL = {
  good:  "pill-connected",
  warn:  "pill-stale",
  muted: "pill-manual",
};

/**
 * Hero status card at the top of the Dashboard. Reuses `automationLevel()`
 * from ConnectorSummary so the wording on the dashboard and the Data Sources
 * page is always identical.
 *
 * Pure presentational: parent owns the data fetch.
 */
export default function HomeIntelligenceCard({ sources }) {
  const safeSources = sources || [];
  const connectedCount = safeSources.filter((s) => s.status === "connected").length;
  const total = safeSources.length;
  const level = automationLevel(safeSources);
  const pill = TONE_PILL[level.tone] || "pill-manual";

  return (
    <section className="card-base p-5" data-testid="home-intelligence-card">
      <div className="flex items-start justify-between gap-4 flex-col md:flex-row">
        <div className="min-w-0">
          <div className="label-tiny mb-1.5 flex items-center gap-2">
            <Sparkles className="w-3 h-3" /> Home Intelligence
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight leading-tight">
            Dreamhouse Flow turns your home into a digital twin.
          </h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-xl leading-relaxed">
            {level.reason}
          </p>
        </div>

        <div className="flex flex-col items-start md:items-end gap-2 flex-shrink-0">
          <div className="label-tiny flex items-center gap-1.5">
            <Activity className="w-3 h-3" /> Status
          </div>
          <span
            className={`pill ${pill} text-sm`}
            data-testid="home-intelligence-level"
            data-level={level.level.toLowerCase()}
          >
            <span className="pill-dot" />
            {level.level}
          </span>
          <div className="text-[11px] text-muted-foreground tabular-nums">
            <span data-testid="home-intelligence-connected">{connectedCount}</span> / {total} sources connected
          </div>
        </div>
      </div>
    </section>
  );
}
